import request from '@/utils/request';
/**获取列表数据 */
export function unitList(data) {
  return request.post('admin/unit/list', data);
}
export function addUnit(data) {
  return request.post('admin/unit/store', data);
}
export function editUnit(data) {
  return request.post('admin/unit/edit', data);
}
export function delUnit(data) {
  return request.post('admin/unit/delete', data);
}
export function unitResource(data) {
  return request.post('admin/unit/resource', data);
}
/**图片上传 */
export const uploadFile = process.env.VUE_APP_BASE_API + 'upload/file';